module.exports = __webpack_public_path__ + "939b5dc55e6b8b317f2ab5ffbfac8ed5.png";